// TYPING-DUAL-ROLE-001 — a user "holds" a role via primary `role`, canonical `role_ids[]` or legacy display `roles[]`.
const norm = (r) => String(r || '').toLowerCase().replace(/[\s-]+/g, '_');
export const holdsRole = (user, key) => {
  if (!user) return false;
  const k = norm(key);
  if (norm(user.role) === k) return true;
  if (Array.isArray(user.role_ids) && user.role_ids.some(r => norm(r) === k)) return true;
  if (Array.isArray(user.roles) && user.roles.some(r => norm(r) === k)) return true;
  return false;
};
export const holdsTypingRole = (user) => holdsRole(user, 'typing_processor');
// RC19 DUAL-ROLE-RBAC-001 — any of the given role keys held (primary, role_ids[] or legacy roles[])
export const holdsAnyRole = (user, keys) => Array.isArray(keys) && keys.some((k) => holdsRole(user, k));
